import { render } from "./TestInstructionsStepTwo.vue?vue&type=template&id=329fbda2&scoped=true&ts=true"
import script from "./TestInstructionsStepTwo.vue?vue&type=script&lang=ts"
export * from "./TestInstructionsStepTwo.vue?vue&type=script&lang=ts"

import "./TestInstructionsStepTwo.vue?vue&type=style&index=0&id=329fbda2&lang=scss&scoped=true"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-329fbda2"]])

export default __exports__